import React from "react";
import axios from "axios";
import FormInput from "../components/FormInput";
import FormSelect from "../components/FormSelect";
import FormDate from "../components/FormDate";
import { Link } from "react-router-dom";
import AjaxError from "../components/AjaxError";
import {
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText
} from "@material-ui/core";
import Loading from "../components/Loading";

const styles = {
  dialog: {
    text: {
      fontSize: 15
    },
    button: {
      fontSize: 15
    }
  }
};

export default class AddPet extends React.Component {
  // Constructor
  constructor(props) {
    super(props);

    // Bindings
    this.createNewPet = this.createNewPet.bind(this);
    this.lookupPolicy = this.lookupPolicy.bind(this);

    // Setup the state
    this.state = {
      error: false,
      errors: [],
      successDialog: false,
      isLoading: false,
      name: "",
      pet_species: 1,
      breed: "",
      dob: new Date(),
      sex: 0,
      sexes: [{ id: 1, name: "Male" }, { id: 2, name: "Female" }],
      yesno: [{ id: 1, name: "Yes" }, { id: 2, name: "No" }],
      desexed: 0,
      microchip: "",
      policy: ""
    };
  }

  componentDidMount() {
    axios
      .get(axios.defaults.baseURL + "/pet/species")
      .then(response => {
        this.setState({ species: response.data.species });
      })
      .catch(e => {
        this.setState({
          isLoading: false,
          error: true,
          errors: e.response.data.errors
        });
      });
  }

  componentDidUpdate(prevProps, prevState) {
    /*
    if (prevState.pet_species !== this.state.pet_species) {
      axios
        .get(
          axios.defaults.baseURL +
            "/pet/breeds?species_id=" +
            this.state.pet_species
        )
        .then(response => {
          this.setState({ breeds: response.data.breeds });
        })
        .catch(e => apiError(this, e));
    }
    */
  }

  lookupPolicy() {
    this.setState({ loadingDialog: true });

    axios
      .get(axios.defaults.baseURL + "/pet/policy/" + this.state.policy)
      .then(response => {
        this.setState({
          name: response.data.policy.pet_name,
          breed: response.data.policy.pet_type
        });
        this.setState({ loadingDialog: false });
      })
      .catch(e => {
        this.setState({
          isLoading: false,
          error: true,
          errors: ["Invalid Policy Number"]
        });
      });
  }

  createNewPet(e) {
    e.preventDefault();
    axios
      .post(axios.defaults.baseURL + "/pet", this.state)
      .then(response => {
        console.log(response.data);
        this.setState({ successDialog: true });
      })
      .catch(e => {
        this.setState({
          isLoading: false,
          error: true,
          errors: e.response.data.errors
        });
      });
  }

  cancelPet() {
    window.location = "/myaccount";
  }

  render() {
    if (this.state.error) {
      return (
        <AjaxError
          open={this.state.error}
          errors={this.state.errors}
          action={() => {
            this.setState({ error: false });
          }}
        />
      );
    }

    return (
      <div>
        <Dialog open={this.state.successDialog}>
          <DialogTitle style={styles.dialog.heading}>
            Successfully Added Your Pet
          </DialogTitle>
          <DialogContent>
            <DialogContentText style={styles.dialog.text}>
              You have successfully added your pet to Vetchat. You are now
              ready to start a consultation.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Link to="/myaccount" className="btn btn-success">
                My Account
            </Link>
          </DialogActions>
        </Dialog>

        <Dialog open={this.state.isLoading}>
          <DialogContent>
            <Loading />
            <br />
            <br />
          </DialogContent>
        </Dialog>

        <div className="row">
          <div className="col-sm-5 col-sm-push-3">
            <h1>Add New Pet</h1>
            <br />
            <p>
              If you have more than one pet covered by a Woolworths pet
              insurance policy you can add them here. The details must match
              details of your policy purchased 07/01/2019 and 31/03/2019.
            </p>
          </div>
        </div>
        <div className="col-sm-5 col-sm-push-3">
        <form className="form-horizontal form-add-pet">
          {FormInput(
            this,
            "Your policy number",
            "policy",
            "text",
            null,
            this.lookupPolicy,
            "col-sm-12",
          )}
          <hr />
          {FormInput(this, "Your pet's name", "name", "text", null, null,"col-sm-12",)}
          {FormInput(this, "Your pet's breed", "breed", "text", null, null,"col-sm-12",)}
          <hr />
          {FormDate(this, "Your pet's date of birth", "dob", "col-sm-12",)}
          {FormSelect(this, "Sex", "sex", this.state.sexes, "col-sm-12" )}
          {FormSelect(this, "Desexed", "desexed", this.state.yesno, "col-sm-12")}
          <div className="addpet-buttons-div">
            <button
              className="btn btn-transparent"
              onClick={this.cancelPet}
              type="button"
            >
              Cancel
            </button>
            <button
              className="btn btn-success"
              onClick={this.createNewPet}
            >
              Add new pet
            </button>
          </div>
        </form>
        </div>
      </div>
    );
  }
}
